<template>
  <div class="relative">
    <!-- Botão que abre o popover -->
    <button @click="togglePopover" class="min-w-45 flex items-center justify-center gap-2 bg-green-dark px-4 py-3 text-white hover:bg-emerald-600">
      <IcDownload v-if="!isLoadingShareButton" class="h-5 w-5 text-white" />
      <span v-else class="animate-spin">
        <IcAnimateSpin class="h-5 w-5 text-white" />
      </span>
      <span>{{ buttonText }}</span>
    </button>

    <!-- Popover -->
    <div v-if="isPopoverOpen" class="absolute right-0 top-full z-50 mt-2 w-80 border border-gray-200 bg-white shadow-lg">
      <div class="p-4">
        <h3 class="mb-4 text-lg font-semibold text-gray-900">{{ title }}</h3>

        <!-- Seção Capturar Gráficos -->
        <div class="mb-6">
          <h4 class="mb-3 text-sm font-medium text-gray-700">Capturar Gráficos</h4>
          <button
            @click="captureCharts"
            class="flex w-full items-center justify-center gap-2 bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700">
            <IcDownload class="h-4 w-4" />
            <span>Capturar Gráficos</span>
          </button>
        </div>

        <!-- Seção Gerar Planilhas -->
        <div>
          <h4 class="mb-3 text-sm font-medium text-gray-700">Gerar Planilhas CSV</h4>

          <!-- Slot para opções específicas -->
          <div class="mb-4">
            <slot name="options" :selected-options="selectedOptions" />
          </div>

          <!-- Botão Gerar CSV -->
          <button
            @click="generateCSV"
            :disabled="!hasSelectedOptions"
            class="flex w-full items-center justify-center gap-2 bg-green-600 px-4 py-2 text-white transition-colors hover:bg-green-700 disabled:cursor-not-allowed disabled:bg-gray-400">
            <IcDownload class="h-4 w-4" />
            <span>Gerar CSV</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Overlay para fechar o popover -->
    <div v-if="isPopoverOpen" @click="closePopover" class="fixed inset-0 z-40"></div>
  </div>
</template>

<script setup lang="ts">
import IcAnimateSpin from '@/components/Icons/IcAnimateSpin.vue'
import IcDownload from '@/components/Icons/IcDownload.vue'

interface Props {
  title?: string
  buttonText?: string
  isPopoverOpen: boolean
  isLoadingShareButton: boolean
  hasSelectedOptions: boolean
  selectedOptions: Record<string, boolean>
}

interface Emits {
  (e: 'toggle-popover'): void
  (e: 'close-popover'): void
  (e: 'capture-charts'): void
  (e: 'generate-csv'): void
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Opções de Compartilhamento',
  buttonText: 'Compartilhar',
})

const emit = defineEmits<Emits>()

const togglePopover = () => emit('toggle-popover')
const closePopover = () => emit('close-popover')
const captureCharts = () => emit('capture-charts')
const generateCSV = () => emit('generate-csv')
</script>
